import { Component, Input } from '@angular/core';
import { environment } from '@environments/environment';
import { IntlService } from '@progress/kendo-angular-intl';
import { BaseCardComponent } from "./base-card.component";
import { AuthService } from '@app/core/services';
import { Router } from '@angular/router';


@Component({
  selector: 'expense-card',
  styleUrls: ['./styles/styles-card.css'],
  styles: [`
    .card{
      height: 74px;
    }
  `],
  template: `
    <!--{{expense | json}}-->
    <div class="card" [class.border-top]="borderTop" (click)="selectItem($event)">  
      <kendo-avatar [imageSrc]="defaultImage" shape="circle" style="background-size: contain; padding: 6px; background-color: #2ecc71"></kendo-avatar>          
      <div class="card-details">
        <div class="card-title">
          {{ intl.formatNumber(expense.cost, "c2", "en") }} <span class="right">{{ getDate(expense.date) }}</span>
        </div>
        <div class="card-subtitle">
          {{ expense.expense_type_name }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ expense.description }}, {{ expense.supplier }}
        </div>
        <div class="card-subtitle no-wrap">
          {{ expense.payment_type_name }}, {{ expense.person_authorize_name }}
        </div>
      </div>
      <div class="card-actions" *ngIf="authService.hasPermission(['GASTOS:EDITAR','GASTOS:ELIMINAR'])">
        <span class="k-icon k-icon-md k-i-arrow-chevron-right k-color-secondary" style="color: #2ecc71!important"></span>
      </div>
    </div>
  `,    
})
export class ExpenseCardComponent extends BaseCardComponent {

  @Input() expense!: any;

  @Input() defaultImage: string = environment.assets.DEFAULT_EXPENSE;

  @Input() returnUrl: string;


  constructor(public intl: IntlService, public router: Router, public authService: AuthService) { 

    super(intl, router)

  }

  public selectItem(event: any) {

    this.router.navigate(['/expense_edit/' + this.expense.id], {state: {returnUrl: this.returnUrl}});

  }

}